import { iCAAccountTypeFromJSON } from "./ica_account";
import { Long } from "@osmonauts/helpers";
export const AminoConverter = {
  "/stride.stakeibc.MsgLiquidStake": {
    aminoType: "stakeibc/LiquidStake",
    toAmino: ({
      creator,
      amount,
      hostDenom
    }) => {
      return {
        creator,
        amount,
        host_denom: hostDenom
      };
    },
    fromAmino: ({
      creator,
      amount,
      host_denom
    }) => {
      return {
        creator,
        amount,
        hostDenom: host_denom
      };
    }
  },
  "/stride.stakeibc.MsgLSMLiquidStake": {
    aminoType: "stakeibc/LSMLiquidStake",
    toAmino: ({
      creator,
      amount,
      lsmTokenIbcDenom
    }) => {
      return {
        creator,
        amount,
        lsm_token_ibc_denom: lsmTokenIbcDenom
      };
    },
    fromAmino: ({
      creator,
      amount,
      lsm_token_ibc_denom
    }) => {
      return {
        creator,
        amount,
        lsmTokenIbcDenom: lsm_token_ibc_denom
      };
    }
  },
  "/stride.stakeibc.MsgRedeemStake": {
    aminoType: "stakeibc/RedeemStake",
    toAmino: ({
      creator,
      amount,
      hostZone,
      receiver
    }) => {
      return {
        creator,
        amount,
        host_zone: hostZone,
        receiver
      };
    },
    fromAmino: ({
      creator,
      amount,
      host_zone,
      receiver
    }) => {
      return {
        creator,
        amount,
        hostZone: host_zone,
        receiver
      };
    }
  },
  "/stride.stakeibc.MsgRegisterHostZone": {
    aminoType: "stakeibc/RegisterHostZone",
    toAmino: ({
      connectionId,
      bech32prefix,
      hostDenom,
      ibcDenom,
      creator,
      transferChannelId,
      unbondingPeriod,
      minRedemptionRate,
      maxRedemptionRate,
      lsmLiquidStakeEnabled
    }) => {
      return {
        connection_id: connectionId,
        bech32prefix,
        host_denom: hostDenom,
        ibc_denom: ibcDenom,
        creator,
        transfer_channel_id: transferChannelId,
        unbonding_period: unbondingPeriod.toString(),
        min_redemption_rate: minRedemptionRate,
        max_redemption_rate: maxRedemptionRate,
        lsm_liquid_stake_enabled: lsmLiquidStakeEnabled
      };
    },
    fromAmino: ({
      connection_id,
      bech32prefix,
      host_denom,
      ibc_denom,
      creator,
      transfer_channel_id,
      unbonding_period,
      min_redemption_rate,
      max_redemption_rate,
      lsm_liquid_stake_enabled
    }) => {
      return {
        connectionId: connection_id,
        bech32prefix,
        hostDenom: host_denom,
        ibcDenom: ibc_denom,
        creator,
        transferChannelId: transfer_channel_id,
        unbondingPeriod: Long.fromString(unbonding_period),
        minRedemptionRate: min_redemption_rate,
        maxRedemptionRate: max_redemption_rate,
        lsmLiquidStakeEnabled: lsm_liquid_stake_enabled
      };
    }
  },
  "/stride.stakeibc.MsgClaimUndelegatedTokens": {
    aminoType: "stakeibc/ClaimUndelegatedTokens",
    toAmino: ({
      creator,
      hostZoneId,
      epoch,
      sender
    }) => {
      return {
        creator,
        host_zone_id: hostZoneId,
        epoch: epoch.toString(),
        sender
      };
    },
    fromAmino: ({
      creator,
      host_zone_id,
      epoch,
      sender
    }) => {
      return {
        creator,
        hostZoneId: host_zone_id,
        epoch: Long.fromString(epoch),
        sender
      };
    }
  },
  "/stride.stakeibc.MsgRebalanceValidators": {
    aminoType: "stakeibc/RebalanceValidators",
    toAmino: ({
      creator,
      hostZone,
      numRebalance
    }) => {
      return {
        creator,
        host_zone: hostZone,
        num_rebalance: numRebalance.toString()
      };
    },
    fromAmino: ({
      creator,
      host_zone,
      num_rebalance
    }) => {
      return {
        creator,
        hostZone: host_zone,
        numRebalance: Long.fromString(num_rebalance)
      };
    }
  },
  "/stride.stakeibc.MsgAddValidators": {
    aminoType: "/stride.stakeibc.MsgAddValidators",
    toAmino: ({
      creator,
      hostZone,
      validators
    }) => {
      return {
        creator,
        host_zone: hostZone,
        validators: validators.map(el0 => ({
          name: el0.name,
          address: el0.address,
          weight: el0.weight.toString(),
          delegation: el0.delegation,
          slash_query_progress_tracker: el0.slashQueryProgressTracker,
          slash_query_checkpoint: el0.slashQueryCheckpoint,
          internal_shares_to_tokens_rate: el0.internalSharesToTokensRate,
          delegation_changes_in_progress: el0.delegationChangesInProgress.toString(),
          slash_query_in_progress: el0.slashQueryInProgress
        }))
      };
    },
    fromAmino: ({
      creator,
      host_zone,
      validators
    }) => {
      return {
        creator,
        hostZone: host_zone,
        validators: validators.map(el0 => ({
          name: el0.name,
          address: el0.address,
          weight: Long.fromString(el0.weight),
          delegation: el0.delegation,
          slashQueryProgressTracker: el0.slash_query_progress_tracker,
          slashQueryCheckpoint: el0.slash_query_checkpoint,
          internalSharesToTokensRate: el0.internal_shares_to_tokens_rate,
          delegationChangesInProgress: Long.fromString(el0.delegation_changes_in_progress),
          slashQueryInProgress: el0.slash_query_in_progress
        }))
      };
    }
  },
  "/stride.stakeibc.MsgChangeValidatorWeight": {
    aminoType: "stakeibc/ChangeValidatorWeight",
    toAmino: ({
      creator,
      hostZone,
      valAddr,
      weight
    }) => {
      return {
        creator,
        host_zone: hostZone,
        val_addr: valAddr,
        weight: weight.toString()
      };
    },
    fromAmino: ({
      creator,
      host_zone,
      val_addr,
      weight
    }) => {
      return {
        creator,
        hostZone: host_zone,
        valAddr: val_addr,
        weight: Long.fromString(weight)
      };
    }
  },
  "/stride.stakeibc.MsgDeleteValidator": {
    aminoType: "stakeibc/DeleteValidator",
    toAmino: ({
      creator,
      hostZone,
      valAddr
    }) => {
      return {
        creator,
        host_zone: hostZone,
        val_addr: valAddr
      };
    },
    fromAmino: ({
      creator,
      host_zone,
      val_addr
    }) => {
      return {
        creator,
        hostZone: host_zone,
        valAddr: val_addr
      };
    }
  },
  "/stride.stakeibc.MsgRestoreInterchainAccount": {
    aminoType: "stakeibc/RestoreInterchainAccount",
    toAmino: ({
      creator,
      chainId,
      accountType
    }) => {
      return {
        creator,
        chain_id: chainId,
        account_type: accountType
      };
    },
    fromAmino: ({
      creator,
      chain_id,
      account_type
    }) => {
      return {
        creator,
        chainId: chain_id,
        accountType: iCAAccountTypeFromJSON(account_type)
      };
    }
  },
  "/stride.stakeibc.MsgUpdateValidatorSharesExchRate": {
    aminoType: "stakeibc/UpdateValidatorSharesExchRate",
    toAmino: ({
      creator,
      chainId,
      valoper
    }) => {
      return {
        creator,
        chain_id: chainId,
        valoper
      };
    },
    fromAmino: ({
      creator,
      chain_id,
      valoper
    }) => {
      return {
        creator,
        chainId: chain_id,
        valoper
      };
    }
  },
  "/stride.stakeibc.MsgClearBalance": {
    aminoType: "still-no-defined",
    toAmino: ({
      creator,
      chainId,
      amount,
      channel
    }) => {
      return {
        creator,
        chain_id: chainId,
        amount,
        channel
      };
    },
    fromAmino: ({
      creator,
      chain_id,
      amount,
      channel
    }) => {
      return {
        creator,
        chainId: chain_id,
        amount,
        channel
      };
    }
  }
};